module.exports = "<div class=items> <md-card flex> <rkc-toolbarheader toolbarheader-definition=c.toolbarheaderDefinition></rkc-toolbarheader> <rkc-searchform search-definition=c.searchDefinition></rkc-searchform> </md-card> <md-card ng-if=\"c.tableDefinition.promise || c.items.length > 0\"> <rkc-table table-definition=c.tableDefinition table-content=c.items></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/items/items.html
 ** module id = 506
 ** module chunks = 0
 **/